import { useState } from 'react';

import { useConnection } from './store/connection';
import { useStore } from './store/store';
import { AvoidButton } from './ui/AvoidSheet';
import { Editor } from './ui/Editor';
import { Home } from './ui/Home';
import { Library } from './ui/Library';
import { Onboarding } from './ui/Onboarding';
import { ProfileMenu } from './ui/ProfileMenu';
import { Settings } from './ui/Settings';
import { Voice } from './ui/Voice';

type Tab = 'home' | 'library' | 'editor' | 'voice' | 'settings';

const TABS: { id: Tab; label: string }[] = [
  { id: 'home', label: 'Home' },
  { id: 'library', label: 'Library' },
  { id: 'editor', label: 'Editor' },
  { id: 'voice', label: 'Voice' },
];

export function App() {
  const store = useStore();
  const conn = useConnection();
  const [tab, setTab] = useState<Tab>('library');

  if (!store.onboarded) return <Onboarding />;

  return (
    <div className="app">
      <header className="topbar">
        <ProfileMenu />
        <div className="spacer" />
        {conn.state === 'connected' ? <span className="badge good">Connected</span> : null}
        <AvoidButton />
        <button
          className="icon-btn"
          aria-label="Settings"
          aria-pressed={tab === 'settings'}
          onClick={() => setTab(tab === 'settings' ? 'library' : 'settings')}
        >
          ⚙
        </button>
      </header>

      <main className="main">
        {tab === 'home' ? <Home onEdit={() => setTab('editor')} /> : null}
        {tab === 'library' ? <Library onEdit={() => setTab('editor')} /> : null}
        {tab === 'editor' ? <Editor /> : null}
        {tab === 'voice' ? <Voice onEdit={() => setTab('editor')} /> : null}
        {tab === 'settings' ? <Settings /> : null}
      </main>

      <nav className="tabbar">
        {TABS.map((t) => (
          <button key={t.id} aria-selected={tab === t.id} onClick={() => setTab(t.id)}>
            {t.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
